import React, { useMemo } from "react";
import AppIcon from "components/ui/AppIcon.jsx";
import AppSwitch from "components/ui/AppSwitch.jsx";
import { useSelector } from "react-redux";

// Custom hook that returns the delivery zone columns
export const useDeliveryZoneColumns = ({ onEdit, onDelete, onStatusChange }) => {
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);

  return useMemo(
    () => [
      {
        title: "Area",
        dataIndex: "areaName",
        render: (val, row) => {
          return row?.areaID?.[`areaName${currentLanguage}`];
        },
      },
      {
        title: "City Name",
        dataIndex: "cityName",
        render: (val, row) => {
          return row?.cityID?.[`cityName${currentLanguage}`];
        },
      },
      {
        title: "Min. Basket Value",
        dataIndex: "minOrder",
        render: (v) =>
          v != null && Number.isFinite(Number(v))
            ? `AED ${Number(v).toFixed(2)}`
            : "—",
      },
      {
        title: "Delivery Fee",
        dataIndex: "deliveryFee",
        render: (v) =>
          v != null && Number.isFinite(Number(v))
            ? `AED ${Number(v).toFixed(2)}`
            : "—",
      },
      {
        title: "Delivery Time",
        dataIndex: "deliveryTime",
      },
      {
        title: "Status",
        dataIndex: "isActive",
        render: (v,row) => {
          return <AppSwitch checked={v} onChange={(val) => onStatusChange(row,val)} />;
        },
      },
      {
        title: "Actions",
        key: "actions",
        // fixed: "right",
        render: (_, row) => (
          <div className="flex justify-start gap-3">
            <span onClick={() => onEdit(row)}>
              <AppIcon name="edit" className="cursor-pointer" />
            </span>
            <span onClick={() => onDelete(row)}>
              <AppIcon name="trash" className="cursor-pointer" />
            </span>
          </div>
        ),
      },
    ],
    [currentLanguage, onEdit, onDelete, onStatusChange]
  );
};
